import React, { memo, useMemo } from 'react';
import { format, getYear, parseISO } from 'date-fns';
import Text from 'design-system/Text';
import { rem } from 'design-system/values';
import IconArrowTriangle from 'design-system/icons/IconArrowTriangle';
import useColors from 'hooks/useColors';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import TouchableOpacity from 'utils/packages/TouchableOpacity';
const TransactionDateButton = ({ transaction, onPressDate, disabled, }) => {
    const pressDate = () => {
        if (onPressDate) {
            onPressDate();
        }
    };
    const date = useMemo(() => {
        if (!transaction)
            return null;
        const customDate = 'customDate' in transaction ? transaction.customDate : null;
        const bookingDate = 'bookingDate' in transaction ? transaction.bookingDate : null;
        const groupTxnDate = 'date' in transaction ? transaction.date : null;
        const dateToDisplay = customDate || bookingDate || groupTxnDate || new Date().toISOString();
        const showYear = getYear(parseISO(dateToDisplay)) !== getYear(new Date());
        return format(parseISO(dateToDisplay), showYear ? 'EEE, MMM d yyyy' : 'EEE, MMM d');
    }, [transaction]);
    const colors = useColors();
    const styles = useStyles(styleSet);
    if (!date)
        return null;
    return (<TouchableOpacity disabled={disabled} hoverOnDark onPress={pressDate} style={styles.dateButton}>
      <Text Text-14>{date}</Text>
      {!disabled && (<IconArrowTriangle style={styles.arrowDown} color={colors.elements.primary}/>)}
    </TouchableOpacity>);
};
export const HEIGHT = 32;
const styleSet = createStyleSheets((colors) => ({
    dateButton: {
        height: rem(32),
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        paddingLeft: rem(16),
        paddingRight: rem(12.83),
        backgroundColor: colors.cards.onDark,
        borderRadius: rem(8),
    },
    web: {
        paddingRight: rem(16),
    },
    arrowDown: {
        marginStart: rem(8),
    },
}));
export default memo(TransactionDateButton);
